// extracted by mini-css-extract-plugin
export var deleteModal = "_se-0";